import React, { Component } from "react";
import Icon from "../../2/Controls/Icon";
import Tab from "../../2/Controls/Tab";
import ViewPage from "../../2/Controls/ViewPage";
import ProductOverview from "./ProductOverview";
import ProductInstock from "./ProductInstock";
import ProductSalesTransaction from "./ProductSalesTransaction";
import ProductInventoryTransaction from "./ProductInventoryTransaction";
import ProductAuditTrial from "./ProductAuditTrial";

class ViewProduct extends Component {

  constructor(props) {
    super(props);
    
    // Get productData from props or define it
    const productData = this.props.product || {};

    this.state = {
      activeTab: "overview" // Initialize activeTab
    };
  }

  getTabs = () => {
    const productData = this.props.product || {};
    
    return [
      { name: "overview", label: "Overview" },
      ...(productData.hasOwnProperty('ProductTypeID') && (productData.ProductTypeID === 1 || productData.ProductTypeID === 2) 
        ? [{ name: "instock", label: "In Stock" }] 
        : []),
      { name: "sales", label: "Sales Transactions" },
      ...(productData.hasOwnProperty('ProductTypeID') && (productData.ProductTypeID === 1 || productData.ProductTypeID === 2) 
        ? [{ name: "inventory", label: "Inventory Transactions" }] 
        : []),
      { name: "audit", label: "Audit Trail" },
    ];
  }
 
  render() {
    const product = this.props.product || {};
    const isAllowUpdate = this.props.isAllowUpdate;
    const isAllowDelete = this.props.isAllowDelete;

    // Check if product has Name property
    const productName = product.hasOwnProperty('Name') ? product.Name : "Product Name";
    const isDeleted = product.hasOwnProperty('IsDeleted') ? product.IsDeleted : false;

    return (
      <>
        <ViewPage
          {...this.props}
          name={productName}
          iconButtons={[
            // Conditionally add "Edit" button
            ...(isDeleted && isAllowUpdate
              ? []
              : [{
                  label: "Edit",
                  onClick: this.props.handleEditBtnClick,
                  icon:"edit",
                  tooltipWidth: "100px",
                }]),
            // Conditionally add "Delete" button
            ...(!isDeleted && isAllowDelete
              ? [{
                  label: "Delete",
                  onClick: this.props.handleDeleteBtnClick,
                  icon:"delete",
                  tooltipWidth: "100px",
                }]
              : []),
          ]}
          handleRemoveBtnClick={this.props.onClose}
          tabs={
            <Tab 
              tabs={this.getTabs()} 
              isNowrap={true} 
              activeTab={this.state.activeTab} 
              onTabChange={(tabName) => {
                this.setState({ activeTab: tabName });
              }} 
            />
          }
        >
          {/* Your content here based on activeTab */}
          {this.state.activeTab === "overview" && <ProductOverview {...this.props} productData={product}/>}
          {this.state.activeTab === "instock" && <ProductInstock {...this.props} productData={product} /> }
          {this.state.activeTab === "sales" && <ProductSalesTransaction {...this.props} productData={product} />}
          {this.state.activeTab === "inventory" && <ProductInventoryTransaction {...this.props} productData={product} />}
          {this.state.activeTab === "audit" && <ProductAuditTrial {...this.props} productData={product} />}
        </ViewPage>
      </>
    );
  }
}

export default ViewProduct;